import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useNavigate } from 'react-router'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { useCloneStrategyMemoMutation } from '../hooks/useCloneStrategyMemoMutation'
import { type InputValues } from '../utils'

export const StrategyMemoCloneButton = () => {
  const {
    formState: { isDirty },
  } = useFormContext<InputValues>()

  const navigate = useNavigate()
  const brandAccountId = useBrandAccountId()
  const cloneStrategyMemoMutation = useCloneStrategyMemoMutation({
    onSuccess: (strategyMemoId) => {
      navigate(compile('strategyMemoEdit', { brandAccountId, strategyMemoId }))
    },
  })
  const handleClick = React.useCallback<EH<IconButtonProps, 'onClick'>>(() => {
    cloneStrategyMemoMutation.mutate()
  }, [cloneStrategyMemoMutation])

  return (
    <IconButton
      disabled={isDirty || cloneStrategyMemoMutation.isPending}
      fillMode="outline"
      icon="copy"
      onClick={handleClick}
    />
  )
}
